import React from 'react'

import { isMobileOrIPad } from 'utils/device'

import Slide from './Slide'
import { slides as slidesData } from './slides'
import { Wrapper, Slider } from './styles'

const sliderSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
}

const CrossSeller = () => {
    if (isMobileOrIPad) return null

    const slides = slidesData.map((slide, index) => (
        <Slide key={index} {...slide} />
    ))

    return (
        <Wrapper>
            <Slider {...sliderSettings}>{slides}</Slider>
        </Wrapper>
    )
}

export default CrossSeller
